import { render, staticRenderFns } from "./PatientNote.vue?vue&type=template&id=26db126f&"
import script from "./PatientNote.vue?vue&type=script&lang=js&"
export * from "./PatientNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports